import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { FetchInstallationsUpdatesStatusServerReqData } from "./FetchInstallationsUpdatesStatusRequestData";

const ENDPOINT = "/device_update/download_data";

export class DownloadUpdatesStatusDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsUpdatesStatusServerReqData;

    constructor(downloadType: string, filters: FetchInstallationsUpdatesStatusServerReqData) {
        super();
        if (downloadType == "csv") this.responseType = "text";
        else if (downloadType == "exp") this.responseType = "blob";
        this.endPoint = this.endPoint + "/" + downloadType;
        this.payload = filters;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand({ ...this.payload });
    }
}
